
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Derss Designing Competition </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm itoohavetalent section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Dress <span > Designing </span>Competition</h2>
        </div>

        <div class="up-event">
            <div class="row">
                <div class="col-md-5">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/dress-designing-competition.jpg"
                        alt="GHRSCF">
                </div>
                <div class="col-md-7 ">
                    <div class="widget_title inner-title">
                        <p> We are pleased to invite your institute Students to participate in the Dress Designing
                            Competition (Formal Dress For Office Professionals - Male and Female) , Organized by G H
                            Raisoni Sports and Cultural Foundation for Raisoni
                            Group of Institutions. Held in the Month of February 2023 and the last date of submission of
                            the design is 10th Feb. 2023. Institutes are requested to encourage the students to submit
                            the design on or before the submission
                            date.
                        </p>
                        <p> This competition is a great opportunity for fashion design students to showcase their ideas
                            and creativity. It is open to all students currently enrolled in a fashion design program
                            and the design selected as a winner will be entitled
                            to win <strong> Prizes worth Rs. 21000/- and Rs. 11,000/- Respectively</strong> to Winner
                            and Runner up. </p>
                        <p> The Design must include all the details and should consider the point that the design is to
                            be made for the Male and Female both. The designer Should consider the point that the Design
                            for Female Office Professionals will be of
                            Indian and western both (Salwar Suit and Trouser and Shirt / Top /Kurti ). For Male the
                            Design will be as per the formal dress protocols. </p>
                    </div>
                </div>
                <div class="col-md-12 ">

                    <p>The Design is to be submitted on
                        <a href="mailto:ghrscf.connect@raisoni.net"> <strong>ghrscf.connect@raisoni.net </strong> </a>
                    </p>
                    <div class="fide-chess-text">
                        <p>We look forward to seeing your amazing designs at the competition. If you need any additional
                            information, please do not hesitate to contact us.</p>
                    </div>
                </div>

            </div>
        </div>
        <div class="up-event">
            <h5>Additional Information: </h5>
            <p>Raisoni Group of Institutions’, an abode sheltering the core of the past, visualization of the present,
                and hope of the future in Indian society. Born in the year 1998 as an Engineering & Polytechnic College
                in Nagpur, G H Raisoni College
                of Engineering, RGI has expanded its vision and reach to be the ‘Home to 19 Institutes, including 2
                State Private Universities’ spread across 319 acres of land. Today, RGI firmly stands as an address to
                education, character building, cultural
                progress, economic progress, and overall development of life with all parameters of living and thriving
                in the society.</p>
            <p>In Raisoni, the work culture is friendly. We are highly professional for the world outside, whereas, the
                bond between all is a family like. We are connected with the national and international institutes
                through various projects and ventures.
                With education, we have our in-house departments for publication, photography, Videography, PR, CSR,
                Sports and Culture. </p>
            <p>This competition is a great opportunity for fashion design students to showcase their ideas and
                creativity. It is open to all students currently enrolled in a fashion design program and the designer
                selected as a winner will be entitled to
                win Prizes worth Rs. 21000/- and Rs. 11,000/- Respectively to Winner and Runner up. </p>
            <h5>Objective and requirements:</h5>
            <ul class="list-style list-style1">
                <li>The objectives of a dress code for office staff typically include promoting a professional image,
                    maintaining a level of consistency and uniformity among employees, and ensuring that clothing is
                    appropriate for the work environment. </li>
                <li>Additionally, a dress code may help to establish a sense of pride and unity among staff members, and
                    can also be used to convey a company's values and culture. </li>
                <li>Some companies also establish dress codes to ensure that employees are dressed appropriately for
                    safety reasons.</li>
                <li>Modest attire: Clothing should not be revealing or excessively tight-fitting.</li>
                <li>Age Group - From 21 to 75 all non teaching </li>
                <li>Sizes - from XS to XXL</li>
                <li>The attire is required with the details of fabric and concept behind the design</li>
                <li>There is a freedom of creativity to students </li>
                <li>Submission can take place as a sketch , whereas illustrated submission is preferred to get a better
                    Idea - it can be submitted in hard copy to 5th Floor, Riaan House, Kingsway, Nagpur 01</li>
            </ul>
            <p>The Design must include all the details and should consider the point that the design is to be made for
                the Male and Female both. The designer Should consider the point that the Design for Female Office
                Professionals will be of Indian and
                western both (Salwar Suit and Trouser and Shirt / Top /Kurti ). For Male the Design will be as per the
                formal dress protocols. </p>
            <ul class="list-style list-style1">
                <li>Eligibility: The Participant must be a students of registered Fashion Designing Institute or the
                    Institute that has received the Invitation of participation </li>
                <li>Theme: Formal Dress Design for the male and Female - Office Professionals </li>
                <li>Design Guidelines: The design is required for the Staff where male and female both work on an equal
                    capacity. The design should be professional yet elegant and comfortable. The Design should be made
                    keeping in mind the comfortability of
                    Indian dress such as Salwar Suit and Western such as trousers and Shirt / Tops for Female and Formal
                    dress of Male - Trouser and Shirt . It should also include Jacket Design for Winters and one casual
                    dress for saturday. (or relative
                    designs for the same.)</li>
                <li>Submission: Designers will typically be required to submit sketches, technical drawings, and/or
                    photographs of their designs to the competition on or before 10th Feb 2023. Presentations made in
                    paper or Fabric will be most appreciated.
                </li>
                <li>Judging: A panel of judges will typically evaluate the designs and select the winners based on
                    criteria such as originality, creativity, and adherence to the theme and guidelines.</li>
                <li>Prizes: All the participants will get the Certificate of Participation. The Winners will get the
                    trophy and prizes as mentioned before.</li>
            </ul>

            <p>It is important for the designer to read and follow the rules closely, as failure to do so may result in
                disqualification.</p>



            <p>The result will be Declared on 13th February 2023 at 5.30 pm on the website - <a
                    href="https://ghrscf.com/"> www.ghrscf.com </a> This will be a primary round result which will
                shortlist the students for the final presentation. Organizers have
                all the rights reserved for any alterations and changes in the requirements or rules.


            </p>

        </div>
    </div>
</section>
